import { FormattedDocument } from "~/composables/useDocuments/useDocumentsTypes";
import { toRefs } from "@vueuse/core";
export interface UsePaymentsState {
  balance: number;
  documents: Array<FormattedDocument>;
}

const usePayments = () => {
  const state = useState<UsePaymentsState>(`usePayments`, () => ({
    balance: 0,
    documents: [],
  }));

  const { BillableStatus } = useDocuments();

  const isBalancePayment = (): boolean => state.value.balance > 0 && state.value.documents.length === 0;

  const isInvoicesPayment = (): boolean =>
    state.value.balance === 0 &&
    state.value.documents.some((document: FormattedDocument) => BillableStatus.includes(document.status));

  const setBalanceToPay = (balance: number): void => {
    state.value.balance = balance;
  };

  const setDocumentsToPay = (documents: Array<FormattedDocument>): void => {
    state.value.documents = documents;
  };

  return {
    isBalancePayment,
    isInvoicesPayment,
    setBalanceToPay,
    setDocumentsToPay,
    ...toRefs(state.value),
  };
};

export default usePayments;
